import { useCouriersWithItinerariesOverPeriodQuery } from 'core/graphql/Couriers/CouriersWithItinerariesOverPeriod.generated';
import { Courier } from 'core/graphql/types';

type CouriersOverPeriodResult = {
  couriers: Courier[];
  areCourierLoading: boolean;
};
const useCouriersOverPeriodDataStore = (
  dateRange: string[] | null,
  agencyId: string | null,
): CouriersOverPeriodResult => {
  const { loading: areCourierIdsLoading, data } =
    useCouriersWithItinerariesOverPeriodQuery({
      skip: !dateRange || !agencyId,
      variables:
        agencyId && dateRange
          ? {
              startDate: dateRange[0],
              endDate: dateRange[1],
              agencyId,
            }
          : undefined,
    });

  if (data !== undefined) {
    return {
      couriers: data.CouriersWithItinerariesOverPeriod,
      areCourierLoading: areCourierIdsLoading,
    };
  }

  return {
    couriers: [],
    areCourierLoading: areCourierIdsLoading,
  };
};

export default useCouriersOverPeriodDataStore;
